import './App.css';
import Home from './components/Home.js'
import AuthPage from './components/AuthPage.js'
import CatalogJewellery from './components/CatalogJewellery.js';
import JewelleryDetails from './components/JewelleryDetails.js';
import VerifyRegistration from './components/VerifyRegistration.js';
import ForgotPassword from './components/ForgotPassword.js';
import NewPassword from './components/NewPassword.js';
import UploadPhoto from './components/UploadPhoto.js';
import UpdateJewelleryDetails from './components/UpdateJewelleryDetails.js';
import Passport from './components/Passport.js';
import BrandAuth from './components/BrandAuth.js';
import BrandDashboard from './components/BrandDashboard.js';
import BrandProfilePage from './components/BrandProfilePage.js';
import ManageCataloguePage from './components/ManageCataloguePage.js';
import UserAuth from './components/UserAuth.js';
import UserCollection from './components/UserCollection.js';
import ProfilePage from './components/ProfilePage.js';
import ClaimTransfer from './components/ClaimTransfer.js';
import EstateShared from './components/EstateShared.js';
import Terms from './components/Terms.js';
import Privacy from './components/Privacy.js';
import Compliance from './components/Compliance.js';
import SiteFooter from './components/SiteFooter.js';
import DeleteAccount from './components/DeleteAccount.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


function App() {

  return (
    <Router>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/login" element={<AuthPage/>}/>
      <Route path="/verify-registration" element={<VerifyRegistration/>}/>
      <Route path="/forgot-password" element={<ForgotPassword/>}/>
      <Route path="/new-password" element={<NewPassword/>}/>
      <Route path="/jewellery" element={<CatalogJewellery/>}/>
      <Route path="/jewellery/details" element={<JewelleryDetails/>}/>
      <Route path="/jewellery/details/update" element={<UpdateJewelleryDetails/>}/>
      <Route path="/jewellery/:qrCodeId" element={<Passport/>}/>
      <Route path="/upload-photo" element={<UploadPhoto/>}/>
      <Route path="/brand" element={<BrandAuth/>}/>
      <Route path="/brand/dashboard" element={<BrandDashboard/>}/>
      <Route path="/brand/profile" element={<BrandProfilePage/>}/>
      <Route path="/brand/catalogue" element={<ManageCataloguePage/>}/>
      <Route path="/user" element={<UserAuth/>}/>
      <Route path="/user/collection" element={<UserCollection/>}/>
      <Route path="/user/profile" element={<ProfilePage/>}/>
      <Route path="/transfer/claim/:tokenId" element={<ClaimTransfer/>}/>
      <Route path="/estate/:token" element={<EstateShared/>}/>
      <Route path="/terms" element={<Terms/>}/>
      <Route path="/privacy" element={<Privacy/>}/>
      <Route path="/compliance" element={<Compliance/>}/>
      {/* Public by design — Play requires the deletion route be reachable from
          the web by someone who has already uninstalled the app. */}
      <Route path="/delete-account" element={<DeleteAccount/>}/>
    </Routes>
    <SiteFooter/>
    </Router>
  );
}

export default App;
